import React from 'react';
import styled from 'styled-components';

const FilterTag = ({ isChecked, name, tagId, onChoose }) => {
  return (
    <Tag>
      <FilterLabel>
        <FilterCheckbox
          value={tagId}
          onChange={() => onChoose(tagId)}
          checked={isChecked}
          type="checkbox"
        />
        {name}
      </FilterLabel>
    </Tag>
  );
};

export default FilterTag;

const Tag = styled.div`
  width: 20%;
  min-width: 200px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  margin: 4px 0;
`;

const FilterCheckbox = styled.input`
  margin-right: 10px;
`;

const FilterLabel = styled.label`
  font-size: 16px;
  cursor: pointer;
`;



// WEBPACK FOOTER //
// ./src/Components/Dishes/FilterBar/FilterTag.jsx